import React from "react";
import { component_tool } from '../../../../tool'
import moment from "moment";
import { WizTableForm } from "../../../common";
let { WizDataTable, WizButton } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

export default (self) => {
  let oper = []
  let btns = (self.getMenuBtn() || []).map((btn) => { return btn['code'] })
  if (btns.indexOf('viewJobs') !== -1) {
    oper.push(
      {
        title: '操作',
        tableItem: {
          fixed: 'right',
          width: 100,
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton tooltip="查看任职" onClick={e => self._onLookPosition(record, e)}>
                查看任职
              </WizButton>
            </WizDataTable.Oper>
          )
        }
      }
    )
  }
  let columns = [
    {
      title: 'examId',
      name: 'examId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        initialValue:null,
        selectType: 'radio',
      },
    },
    {
      title: '岗位',
      name: 'posId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        initialValue:null,
        selectType: 'radio',
      },
    },
    {
      title: '通过状态',
      name: 'pass',
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
      ],
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {}
    },
    // {
    //   title: '证件号码',
    //   name: 'idCard',
    //   tableItem: {}
    // },
    {
      title: '成绩',
      name: 'score',
      tableItem: {}
    },
    {
      title: '状态',
      name: 'pass',
      tableItem: {},
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
      ],
    },
    {
      title: '组织名称',
      name: 'orgName',
      tableItem: {},
    },
    {
      title: '组织编码',
      name: 'orgCode',
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionName',
      tableItem: {}
    },
    {
      title: '任职状态',
      name: 'jobState',
      tableItem: {},
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
    },
    {
      title: '用户属性',
      name: 'userType',
      tableItem: {},
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
      ]
    },
    {
      title: '阅卷时间',
      name: 'markingDate',
      tableItem: {
        render: (text => {
          return formatterDate(text)
        })
      }
    },
    ...oper
  ]
  return columns
}
